import React from 'react';
import {
    Label, FormGroup, Input
  } from 'reactstrap';

const ListKeyValueWidget = ({
    listOfData,
    keyName,
    valueName,
    listItemHandler,
}) => {
    const listCheckBoxHandler = (eventValue, selectedRow) => {
        if (listItemHandler) {
            listItemHandler(eventValue, selectedRow);
        }
    }
    return (
        <div className="site-planning__sidebar-data-widget__list">
        {listOfData && listOfData.map((row, index) =>
            <div key={`row-${index}`}>
                <FormGroup check>
                    <Label check className="site-planning__sidebar-data-widget__list-item">
                        <div
                            style={{
                                backgroundColor: `rgb(${row['rgba_color']})`,
                                width: 20, height: 20,
                                borderRadius: 4,
                                marginRight: 6,
                            }}
                        />
                        <Input
                            type="checkbox"
                            id={`list_key_value-checkbox-${index}`}
                            onChange={(event) => listCheckBoxHandler(event.target.checked, row)}
                        />{' '}
                        {row[keyName]}: {row[valueName]}
                    </Label>
                </FormGroup>
            </div>
        )}
        </div>
    );
}

export default ListKeyValueWidget;